import { render } from "./RentalContractComplete.vue?vue&type=template&id=8baee2fc&ts=true"
import script from "./RentalContractComplete.vue?vue&type=script&lang=ts"
export * from "./RentalContractComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__